// extracted by mini-css-extract-plugin
export default {"bgColor":"Quote_bgColor__SAdUS","textPaddingLeft":"Quote_textPaddingLeft__s3r23","quote":"Quote_quote__kwfN6","quoteTitle":"Quote_quoteTitle__7Uh84"};